<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT">选择银行卡</span>
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />

      <mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />
    </mu-appbar>

    <div style="min-height:13rem ; background-color:#f5f5f5">

      <div v-for=" card,index in Cards ">
        <div style=" height:0.2rem ; background-color:#f5f5f5  "></div>
        <div style="   background-color:#fff ;  " v-on:click="goDirectPay(card.bankName , card.cardType , card.bankCard , card.replaceBankCard)">

          <div style="padding: 0.4rem 0 0.4rem 0.3rem ; overflow:hidden">
            <img :src="'../../static/wallet/banks/'+cardClass(card.bankName)+'.png'" style=" width:0.94rem ; float:left" />

            <div style="float:left ; padding-left:0.24rem">
              <span style="font-size:0.32rem; color:#333 ; font-weight:bold"> {{ card.bankName }} </span>&nbsp;
              <span style="font-size:0.24rem; color:#333 ; font-weight:bold"> {{ card.cardType }} </span>
              <div style="margin-top:0.15rem">
                {{ card.replaceBankCard }}
              </div>
            </div>
            <div>
              <img :src="'../../../static/order/RightArrow.png'" style=" margin:0.3rem ; width:0.24rem ;  float:right" />
            </div>

          </div>
        </div>
      </div>

      <div style=" height:0.2rem ; background-color:#f5f5f5  "></div>
      <div style="   background-color:#fff ;   " align="center" v-on:click="goPayByUnionBeforeBind">

        <img :src="'../../../static/order/添加卡.png'" style=" margin-top:0.4rem ;  width:0.35rem  ;  " />
        <div style="color:#ff9347 ; font-size:0.28rem ; padding-bottom:0.4rem  ;padding-top:0.05rem ; font-weight:bold ">
          使用新的银行卡支付
        </div>

      </div>
    </div>

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>








<script>

// 业务逻辑是这样的

// 先在“ ChooseCard ”这个页面，用户或者选择使用已有卡 ， 或者绑定新卡

// 使用已有卡 - PayByUnionDirect  直接支付

// 绑定新卡 - PayByUnionBeforeBind    这个页面只输入卡号，判断是借记 还是 信用  跳转不同

// 借记

// 信用 - PayByUnionNextCredit


import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'
import bank from '../../../utils/bankCard'



export default {
  computed: {
    ...mapGetters([
      'g_UserInfo', 'g_PayOrder'
    ])
  },
  watch: {
    $route(to, from) {
      if (to.path == "/order/PayByUnion/ChooseCard") {
        // this.init();
      }
    },
  },
  activated() {
    this.init();
  },
  data() {
    return {
      // 弹出层
      toast: false,
      TellUser: '',
      // 弹出标签 选择是否
      dialog: false,

      Cards: [],

    }
  },
  methods: {
    ...mapMutations([
      'setG_PayOrder',
    ]),

    cardClass(name) {
      return bank.cardClass(name);
    },
    init() {
      this.Cards = [];
      this.getMyBankCard();

      var Order = this.g_PayOrder;
      Order.TypeId = this.$route.query.orderType
      this.setG_PayOrder(Order);
      console.log(this.g_PayOrder)
    },

    // 页面展示   银行卡列表
    getMyBankCard() {
      this.$http.post(api.getMyBankCard()).then((res) => {
        console.log(res)
        if (res.Result) {
          this.Cards = res.Data;
        }
        else {
          this.TellUser = res.Message;
          this.showToast();
        }
      })
    },

    goDirectPay(bankName, cardType, bankCard, replaceBankCard) {

      var Order = this.g_PayOrder;

      Order.BankName = bankName;
      Order.CardType = cardType;
      Order.CardNo = bankCard;
      Order.CardReplace = replaceBankCard;   //  注释掉的卡号

      this.setG_PayOrder(Order);

      console.log(this.g_PayOrder)
      this.$router.push({ path: '/order/PayByUnion/DirectPay' });


    },




    goback() {
      javascript: history.go(-1);
    },

    goPayByUnionBeforeBind() {
      this.$router.push({ path: '/order/PayByUnion/BeforeBind' });
    },


    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
      if (this.TellUser == '未登录') {
        this.$http.post(api.LogOff()).then((res) => { });
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1200)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end


  },




}
</script>




<style lang="less" scoped>
@import "../../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor ;
  border: 1px solid @primaryColor ;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange ;
  }
  .Black {
    color: @primaryBlack ;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// ChooseCard.vue?42d97772